import styled from 'styled-components';
import { pluralize } from '../../../../../utils/formatText';
import ThinDivider from '../../../../../components/ThinDivider';
import UserRoleFilter from './UserRoleFilter';
import UserStatusFilter from './UserStatusFilter';
import {
  IMaxSeatsFieldsFragment,
  UserState,
} from '../../../../../utils/apollo/graphqlSchema';
import SearchInput from '../../../../../components/Form/SearchInput';
import InviteNewUserAction from './InviteNewUserAction';
import { TotalLabel } from '../../../../PermissionControls/PermissionControlsUI';
import { MaybeNil } from '../../../../../utils/interfaces';
import { theme } from '../../../../../styles/theme';

interface IProps {
  total: number;
  searchTerm: string;
  setSearchTerm: (searchTerm: string) => void;
  roles: string[];
  setRoles: (roles: string[]) => void;
  states: UserState[];
  setStates: (states: UserState[]) => void;
  pendingUsersRoute: boolean;
  maxSeats: MaybeNil<IMaxSeatsFieldsFragment>;
}

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  column-gap: 16px;
  row-gap: 8px;
`;
const FiltersContainer = styled(Container)`
  margin-right: auto;
`;

const MaxSeatsDisplay = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
  color: ${theme.colors.secondary800};
`;

const UsersFilters = ({
  total,
  searchTerm,
  setSearchTerm,
  roles,
  setRoles,
  states,
  setStates,
  pendingUsersRoute,
  maxSeats,
}: IProps) => {
  return (
    <Container>
      <FiltersContainer>
        <TotalLabel>
          {total} {pluralize('User', total)}
        </TotalLabel>
        <ThinDivider layout="vertical" size="short" />
        <UserRoleFilter roles={roles} setRoles={setRoles} />
        {!pendingUsersRoute && (
          <>
            <ThinDivider layout="vertical" size="short" />
            <UserStatusFilter states={states} setStates={setStates} />
          </>
        )}
      </FiltersContainer>
      {maxSeats && (
        <MaxSeatsDisplay>{`Max seats: ${maxSeats.maxSeats}`}</MaxSeatsDisplay>
      )}
      <InviteNewUserAction />
      <SearchInput
        placeholder={`Search Users`}
        onChange={setSearchTerm}
        value={searchTerm}
      />
    </Container>
  );
};

export default UsersFilters;
